module.exports = __webpack_public_path__ + "img/quran_category.dfb81960.png";